import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PhoneSpecsCondensed } from '../phones'

export type PhoneStateCondensed = Array<PhoneSpecsCondensed>

export const phonesSliceCondensed = createSlice({
  name: 'phonesCondensed',
  initialState: [] as Array<PhoneSpecsCondensed>,
  reducers: {
    setPhonesCondensed: (_state: PhoneStateCondensed, action: PayloadAction<Array<PhoneSpecsCondensed>>) => {
      return action.payload
    },
  },
})

export const requestPhonesCondensed = createAction('requestPhonesCondensed')
export const { setPhonesCondensed } = phonesSliceCondensed.actions
